import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import {
  FaFileInvoice,
  FaMapMarkerAlt,
  FaUserShield,
  FaImages,
  FaArrowLeft,
  FaIdCard,
  FaExpandAlt,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaAlignRight,
  FaUser,
} from "react-icons/fa";

export default function ViolationDetailsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { backEnd_request } = BackMethods();

  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);

  const reportId = new URLSearchParams(location.search).get("id");

  const fetchDetails = async () => {
    setLoading(true);
    try {
      const res = await backEnd_request.get(
        `/ViolationReports/by-id/${reportId}`,
      );
      console.log(res.data);
      setReport(res.data?.[0] || null);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (reportId) fetchDetails();
  }, [reportId]);

  if (loading) return <SkeletonLoader />;

  if (!report)
    return (
      <div className="container py-5 text-center">
        <h4 className="text-muted">بيانات غير متوفرة</h4>
        <button className="btn btn-dark mt-3" onClick={() => navigate(-1)}>
          رجوع
        </button>
      </div>
    );

  return (
    <div className="page" dir="rtl">
      {/* HEADER */}
      <div className="header">
        <div className="container d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <div className="icon-box">
              <FaFileInvoice />
            </div>
            <div>
              <h5 className="mb-1">ضبط #{report.reportNumber}</h5>
              <small className="text-muted">
                {report.reportDate?.split("T")[0]} —{" "}
                {report.reportTime?.slice(0, 5)}
              </small>
            </div>
          </div>

          <button className="btn btn-sm  btn-back" onClick={() => navigate(-1)}>
            رجوع
            <FaArrowLeft />
          </button>
        </div>
      </div>

      {/* QUICK STATS */}
      <div className="container mt-4">
        <div className="stats">
          <Stat label="المخالف" value={report.offenderName} />
          <Stat label="المهمة" value={report.missionNumber} />

          <Stat label="القضية" value={report.caseNumber} />
          {/* <Stat label="الرخصة" value={report.licenseNumber} /> */}
          <Stat label="الكمية" value={report.seizedQuantity} />
          <Stat label="جهة الإيداع" value={report.depositDestination} />
        </div>
      </div>

      <div className="container content">
        <div className="row g-4">
          {/* MAIN */}
          <div className="col-lg-8">
            <Card
              title={"مضمون  لضبط " + report.violationType.name}
              icon={<FaAlignRight />}
              primary
            >
              <p className="summary text-bold text-dark">
                {report.violationSummary || "لا يوجد وصف"}
              </p>
            </Card>

            <Card title="الصور" icon={<FaImages />}>
              <div className="photo-grid">
                {report.photos?.length ? (
                  report.photos.map((p, i) => (
                    <div
                      key={i}
                      className="photo"
                      onClick={() => setCurrentIndex(i)}
                    >
                      <img src={p.photoUrl} />

                      {/* زر فتح في نافذة جديدة */}
                      <button
                        className="open-new-tab-bottom"
                        onClick={(e) => {
                          e.stopPropagation(); // 🔥 يمنع فتح الـ lightbox
                          window.open(p.photoUrl, "_blank");
                        }}
                      >
                        <FaExpandAlt /> عرض
                      </button>

                      <div className="overlay">
                        <FaExpandAlt />
                      </div>
                    </div>
                  ))
                ) : (
                  <Empty text="لا توجد صور" />
                )}
              </div>
            </Card>
          </div>

          {/* SIDEBAR */}
          <div className="col-lg-4">
            <div className="sticky">
              <Card
                className="text-primary"
                title={report.establishment.name}
                icon={<FaMapMarkerAlt />}
              >
                <div className="meta">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      {report.city} - {report.district}
                    </div>

                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() =>
                        navigate(
                          `/admin/establishments/${report.establishmentFieldUid}`,
                        )
                      }
                    >
                      عرض المنشأة
                    </button>
                  </div>
                  <div className="distance">
                    {report.distanceMeters?.toFixed(1)} متر
                  </div>
                </div>
              </Card>

              <Card title="الدورية" icon={<FaUserShield />}>
                {[
                  report.inspector1Name,
                  report.inspector2Name,
                  report.inspector3Name,
                ]
                  .filter(Boolean)
                  .map((n, i) => (
                    <div key={i} className="inspector">
                      <span className="badge">{i + 1}</span>
                      {n}
                    </div>
                  ))}
              </Card>
            </div>
          </div>
        </div>
      </div>

      {/* LIGHTBOX */}
      {currentIndex !== null && (
        <div className="lightbox" onClick={() => setCurrentIndex(null)}>
          <button className="close" onClick={() => setCurrentIndex(null)}>
            <FaTimes />
          </button>

          <img src={report.photos[currentIndex].photoUrl} />

          <div className="counter">
            {currentIndex + 1} / {report.photos.length}
          </div>

          {currentIndex > 0 && (
            <button
              className="nav prev"
              onClick={(e) => {
                e.stopPropagation();
                setCurrentIndex(currentIndex - 1);
              }}
            >
              <FaChevronRight />
            </button>
          )}

          {currentIndex < report.photos.length - 1 && (
            <button
              className="nav next"
              onClick={(e) => {
                e.stopPropagation();
                setCurrentIndex(currentIndex + 1);
              }}
            >
              <FaChevronLeft />
            </button>
          )}
        </div>
      )}

      {/* STYLES */}
      <style>{`

                .open-new-tab-bottom {
                position: absolute;
                bottom: 8px;
                left: 8px;
                right: 8px;
                background: rgba(255,255,255,0.95);
                border: none;
                border-radius: 8px;
                padding: 5px;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 5px;
                cursor: pointer;
                opacity: 0;
                transition: 0.3s;
                z-index: 2;
            }

                .photo:hover .open-new-tab-bottom {
                    opacity: 1;
                }
                .page { background:#f6f8fc; min-height:100vh; }

                .header {
                    position:sticky;
                    top:0;
                    background:white;
                    padding:12px 0;
                    border-bottom:1px solid #eee;
                    z-index:100;
                }

                .icon-box {
                    width:45px;height:45px;
                    background:#111;color:white;
                    display:flex;align-items:center;justify-content:center;
                    border-radius:12px;
                }

                .btn-back {
                    background:#111;color:white;
                    border:none;padding:8px 16px;
                    border-radius:20px;
                    display:flex;gap:5px;
                }

                .stats {
                    display:grid;
                    grid-template-columns:repeat(auto-fit,minmax(120px,1fr));
                    gap:10px;
                }

                .stat {
                    background:white;
                    padding:10px;
                    border-radius:10px;
                    text-align:center;
                    box-shadow:0 2px 10px rgba(0,0,0,0.05);
                }

                .content { margin-top:20px; }

                .card-box {
                    background:white;
                    padding:18px;
                    border-radius:14px;
                    box-shadow:0 4px 15px rgba(0,0,0,0.05);
                }

                .card-title {
                    font-weight:700;
                    margin-bottom:15px;
                    display:flex;gap:10px;
                }

                .grid {
                    display:grid;
                    grid-template-columns:repeat(auto-fit,minmax(180px,1fr));
                    gap:12px;
                }

                .field {
                    background:#f9fafc;
                    padding:10px;
                    border-radius:8px;
                }

                .summary { line-height:1.9; }

                .photo-grid {
                    display:grid;
                    grid-template-columns:repeat(auto-fill,minmax(180px,1fr));
                    gap:12px;
                }

                .photo {
                    height:160px;
                    border-radius:10px;
                    overflow:hidden;
                    position:relative;
                    cursor:pointer;
                }

                .photo img {
                    width:100%;height:100%;
                    object-fit:cover;
                    transition:0.3s;
                }

                .photo:hover img { transform:scale(1.07); }

                .overlay {
                    position:absolute;
                    inset:0;
                    background:rgba(0,0,0,0.4);
                    opacity:0;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    color:white;
                    transition:0.3s;
                }

                .photo:hover .overlay { opacity:1; }

                .sticky { position:sticky; top:90px; }

                .inspector {
                    background:#f1f3f6;
                    padding:8px;
                    border-radius:8px;
                    margin-bottom:8px;
                    display:flex;
                    gap:10px;
                }

                .badge {
                    background:#111;
                    color:white;
                    padding:4px 8px;
                    border-radius:6px;
                }

                .lightbox {
                    position:fixed;
                    inset:0;
                    background:black;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    z-index:9999;
                }

                .lightbox img {
                    max-width:90%;
                    max-height:90%;
                }

                .close {
                    position:absolute;
                    top:20px;
                    right:20px;
                    background:white;
                    border:none;
                    width:40px;height:40px;
                    border-radius:50%;
                }

                .counter {
                    position:absolute;
                    bottom:20px;
                    color:white;
                }

                .nav {
                    position:absolute;
                    top:50%;
                    transform:translateY(-50%);
                    background:none;
                    border:none;
                    color:white;
                    font-size:2rem;
                }

                .prev { right:20px; }
                .next { left:20px; }
            `}</style>
    </div>
  );
}

/* COMPONENTS */

function Card({ title, icon, children }) {
  return (
    <div className="card-box">
      <div className="card-title">
        {icon} {title}
      </div>
      {children}
    </div>
  );
}

function InfoField({ label, value, icon }) {
  return (
    <div className="field">
      <small>
        {icon} {label}
      </small>
      <div className="fw-bold">{value || "---"}</div>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div className="stat">
      <small>{label}</small>
      <div className="fw-bold">{value || "---"}</div>
    </div>
  );
}

function Empty({ text }) {
  return <div className="text-center text-muted p-3">{text}</div>;
}

function SkeletonLoader() {
  return <div className="p-5 text-center">Loading...</div>;
}
